var map = {
	"./editorBaseApi": [
		37897
	],
	"./editorBaseApi.js": [
		37897
	],
	"./editorSimpleWorker": [
		60880
	],
	"./editorSimpleWorker.js": [
		60880
	],
	"./editorWorker": [
		12526
	],
	"./editorWorker.js": [
		12526
	],
	"./editorWorkerHost": [
		4004
	],
	"./editorWorkerHost.js": [
		4004
	],
	"./findSectionHeaders": [
		14085
	],
	"./findSectionHeaders.js": [
		14085
	],
	"./getIconClasses": [
		77206
	],
	"./getIconClasses.js": [
		77206
	],
	"./languageFeatureDebounce": [
		36638
	],
	"./languageFeatureDebounce.js": [
		36638
	],
	"./languageFeatures": [
		33392
	],
	"./languageFeatures.js": [
		33392
	],
	"./languageFeaturesService": [
		39818
	],
	"./languageFeaturesService.js": [
		39818
	],
	"./languageService": [
		38740
	],
	"./languageService.js": [
		38740
	],
	"./languagesAssociations": [
		79126
	],
	"./languagesAssociations.js": [
		79126
	],
	"./languagesRegistry": [
		75497
	],
	"./languagesRegistry.js": [
		75497
	],
	"./markerDecorations": [
		6952
	],
	"./markerDecorations.js": [
		6952
	],
	"./markerDecorationsService": [
		40177
	],
	"./markerDecorationsService.js": [
		40177
	],
	"./model": [
		39800
	],
	"./model.js": [
		39800
	],
	"./modelService": [
		79361
	],
	"./modelService.js": [
		79361
	],
	"./resolverService": [
		81172
	],
	"./resolverService.js": [
		81172
	],
	"./semanticTokensDto": [
		42374
	],
	"./semanticTokensDto.js": [
		42374
	],
	"./semanticTokensProviderStyling": [
		21341
	],
	"./semanticTokensProviderStyling.js": [
		21341
	],
	"./semanticTokensStyling": [
		62993
	],
	"./semanticTokensStyling.js": [
		62993
	],
	"./semanticTokensStylingService": [
		62286
	],
	"./semanticTokensStylingService.js": [
		62286
	],
	"./textModelSync/textModelSync.impl": [
		85005
	],
	"./textModelSync/textModelSync.impl.js": [
		85005
	],
	"./textModelSync/textModelSync.protocol": [
		15386,
		5386
	],
	"./textModelSync/textModelSync.protocol.js": [
		15386,
		5386
	],
	"./textResourceConfiguration": [
		98050
	],
	"./textResourceConfiguration.js": [
		98050
	],
	"./treeSitterParserService": [
		45214
	],
	"./treeSitterParserService.js": [
		45214
	],
	"./treeViewsDnd": [
		29334
	],
	"./treeViewsDnd.js": [
		29334
	],
	"./treeViewsDndService": [
		9190
	],
	"./treeViewsDndService.js": [
		9190
	],
	"./unicodeTextModelHighlighter": [
		48849
	],
	"./unicodeTextModelHighlighter.js": [
		48849
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;